export default __webpack_public_path__ + "static/media/kieran.ba044e3e.jpg";